import { PureFunctional, React } from '../../react';
import cx from './style.less';

export const Navbar = PureFunctional<{
  count: number;
  index: number;
  onNext: any;
  onPrev: any;
  typeName: string;
  visible: boolean;
}>('Navbar')(
  ({ count, index, onNext, onPrev, typeName, visible }) => {
    const pageindex = (index++).toString();
    // const typenaam = typeName;
    const total = count.toString();
    return (
      <div className={cx('footer', !visible ? 'wcag-invisible' : '')}>
        <button className={cx('btn', 'icon-btn', 'icon_arrow-left')} onClick={onPrev}>
          <span></span>
        </button>
        <span className={cx('index')}>Item {pageindex}/{total}</span>
        <button className={cx('btn','icon-btn', 'icon_arrow-right')}  onClick={onNext}>
          <span></span>
        </button>
      </div>
    );},
  );



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/shared/navbar/index.tsx